import { HEADER_LOGO_MOBILE_WIDTH } from '../Global_DS_Header/constants/headerConstants';

export const SharedSimpleHeaderStyles = ({ theme, $isDRSmileInactive }) => `
  width: 100%;
  height: 60px;

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050; 
 
  svg {
    height: auto;
    width: ${$isDRSmileInactive ? `120px` : `${HEADER_LOGO_MOBILE_WIDTH}`};
  }
  
 ${theme.breakpoints.up('lg')} {
    height: 94px;

    svg {
      height: auto;
      width: ${$isDRSmileInactive ? `140px` : `${HEADER_LOGO_MOBILE_WIDTH}`};
   
    }
  
  }
`;

export const SharedProgressStyles = ({ theme, progress }) => `

  transition: width 0.3s ease-in-out;
   :before, :after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 8px;
  }
  
  :before {
    background-color: ${theme.DS_palette.background.lightBlue};
    width: 100%;
  }

  :after {
    background-color: ${theme.DS_palette.buttons.enabled};
    width: calc(100% * ${progress});
    transition: width 0.3s ease-in-out;
    border-radius: 0 8px 8px 0;
  }
  
   ${theme.breakpoints.up('lg')} {

    :before, :after {
       height: 12px;
    }
  
  }
`;
